export const UsLawFirmIcon = ({ color = "#784EFF" }: { color?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Scales" clipPath="url(#clip0_110_16168)">
        <path
          id="Vector"
          opacity="0.2"
          d="M3.08667 15.8125C3.08667 17.4691 4.96167 18.0625 6.08667 18.0625C7.21167 18.0625 9.08667 17.4691 9.08667 15.8125L6.08667 8.3125L3.08667 15.8125Z"
          fill={color}
        />
        <path
          id="Vector_2"
          opacity="0.2"
          d="M16.5867 12.8125C16.5867 14.4691 18.4617 15.0625 19.5867 15.0625C20.7117 15.0625 22.5867 14.4691 22.5867 12.8125L19.5867 5.3125L16.5867 12.8125Z"
          fill={color}
        />
        <path
          id="Vector_3"
          d="M12.8367 3.8125V20.3125"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M10.5867 20.3125H15.0867"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M6.08667 8.3125L19.5867 5.3125"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M3.08667 15.8125C3.08667 17.4691 4.96167 18.0625 6.08667 18.0625C7.21167 18.0625 9.08667 17.4691 9.08667 15.8125L6.08667 8.3125L3.08667 15.8125Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M16.5867 12.8125C16.5867 14.4691 18.4617 15.0625 19.5867 15.0625C20.7117 15.0625 22.5867 14.4691 22.5867 12.8125L19.5867 5.3125L16.5867 12.8125Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16168">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.83667 0.0625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
